import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTransition from 'react-transition-group/Transition'
import Div from 'components/Div'
import * as Animations from './Animations'

const Container = styled(Div)`
  animation-name: ${props => props.show ? props.enterAnimation : props.exitAnimation};
  animation-duration: ${props => props.duration}ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
`

class Transition extends React.PureComponent {
  static propTypes = {
    show: PropTypes.bool,
    duration: PropTypes.number,
    enterAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    exitAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    unmountOnExit: PropTypes.bool,
    mountOnEnter: PropTypes.bool
  }

  static defaultProps = {
    show: false,
    duration: 300,
    enterAnimation: Animations.fadeIn,
    exitAnimation: Animations.fadeOut
  }

  render () {
    const { show, duration, enterAnimation, exitAnimation, mountOnEnter, unmountOnExit, children, className, ...props } = this.props

    return (
      <ReactTransition in={show} timeout={duration} mountOnEnter={mountOnEnter} unmountOnExit={unmountOnExit} {...props}>
        <Container className={className} show={show} duration={duration} enterAnimation={enterAnimation} exitAnimation={exitAnimation}>
          {children}
        </Container>
      </ReactTransition>
    )
  }
}

export default Transition
